export function showElement(el, forceHide) {
  if (el.style.display === 'none') { el.style.display = ''; }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/showElement.js
// module id = 860
// module chunks = 2